import { render, staticRenderFns } from "./AuctionFormReservePrice.vue?vue&type=template&id=36ee6835&scoped=true"
import script from "./AuctionFormReservePrice.vue?vue&type=script&lang=js"
export * from "./AuctionFormReservePrice.vue?vue&type=script&lang=js"
import style0 from "./AuctionFormReservePrice.vue?vue&type=style&index=0&id=36ee6835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ee6835",
  null
  
)

export default component.exports